// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'

export interface VerifyEmailAddress {
  email: string
  organization?: string
  fib?: string
  introducingPartner?: string
  experience?: string
  locale?: string
  source?: string
  promo?: string
  heapUserId?: string
  link?: string
  landingParams?: string
}

export interface SimpleResponse {
  errorText?: string
  ok: boolean
}

/**
 * Validate VerifyEmailAddress request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateVerifyEmailAddress(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateVerifyEmailAddress(request: VerifyEmailAddress): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.email === undefined || req.email === null) {
    errors.push({
      field: 'email',
      code: 'required',
      message: 'email is required'
    })
  }
  if (typeof req.email === 'string' && req.email.length > 64) {
    errors.push({
      field: 'email',
      code: 'too_long',
      message: 'email must not exceed 64 characters',
      argument: '64'
    })
  }
  if (typeof req.email === 'string' && req.email.trim() === '') {
    errors.push({
      field: 'email',
      code: 'required',
      message: 'email cannot be empty'
    })
  }

  if (typeof req.organization === 'string' && req.organization.length > 64) {
    errors.push({
      field: 'organization',
      code: 'too_long',
      message: 'organization must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.fib === 'string' && req.fib.length > 64) {
    errors.push({
      field: 'fib',
      code: 'too_long',
      message: 'fib must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.introducingPartner === 'string' && req.introducingPartner.length > 64) {
    errors.push({
      field: 'introducingPartner',
      code: 'too_long',
      message: 'introducingPartner must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.experience === 'string' && req.experience.length > 64) {
    errors.push({
      field: 'experience',
      code: 'too_long',
      message: 'experience must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.locale === 'string' && req.locale.length > 64) {
    errors.push({
      field: 'locale',
      code: 'too_long',
      message: 'locale must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.source === 'string' && req.source.length > 64) {
    errors.push({
      field: 'source',
      code: 'too_long',
      message: 'source must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.promo === 'string' && req.promo.length > 8192) {
    errors.push({
      field: 'promo',
      code: 'too_long',
      message: 'promo must not exceed 8192 characters',
      argument: '8192'
    })
  }

  if (typeof req.heapUserId === 'string' && req.heapUserId.length > 64) {
    errors.push({
      field: 'heapUserId',
      code: 'too_long',
      message: 'heapUserId must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.link === 'string' && req.link.length > 64) {
    errors.push({
      field: 'link',
      code: 'too_long',
      message: 'link must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.landingParams === 'string' && req.landingParams.length > 8192) {
    errors.push({
      field: 'landingParams',
      code: 'too_long',
      message: 'landingParams must not exceed 8192 characters',
      argument: '8192'
    })
  }

  return errors
}

export const verifyEmailAddress = postEndpoint<VerifyEmailAddress, SimpleResponse>('/auth/verifyEmailAddress')
